import React from 'react'
import { Scrollbars } from 'react-custom-scrollbars';

export class SelectComponent extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      opened: false,
      refSet: false,
      width: 100
    }

    this.componentRef = null

    this.options = null

    this.toggle = this.toggle.bind(this)
    this.chooseOption = this.chooseOption.bind(this)
    this.setComponentRef = this.setComponentRef.bind(this)
  }

  toggle(e) {
    if(e) {
      e.preventDefault()
    }
    this.setState((ps)=> {
      ps.opened = !ps.opened
      return ps
    })
  }

  selectedItem() {
    let res = this.props.opts.find((it)=> it.id == this.props.value)

    if(!res) {
      res = {
        title: 'empty',
        id: -1
      }
    }

    return res
  }

  chooseOption(it) {
    this.props.onChange({target: {value: it.id}})
    this.toggle()
  }

  setComponentRef(ref) {
    if(!ref)
      return
    this.componentRef = ref
    this.setState({
      width: ref.offsetWidth
    })
  }

  render() {
    const s = this.selectedItem()
    const opened = this.state.opened
    const opts = this.props.opts
    return (
      <div className="select-component">
        <div className={ "select-component__title " + (opened ? 'active' : '') } onClick={ this.toggle } ref={this.setComponentRef}>
          { s.title }
        </div>
        { opened &&
          <div>
            <div className="select-component__bg" onClick={this.toggle}></div>
            <div className="select-component__options">
              <Scrollbars
                autoHeight
                autoHeightMin={100}
                autoHeightMax={160}
                style={{width: this.state.width}}
              >
                <ul>
                  { opts.map((it, ind)=> (
                    <li
                      key={ind}
                      className={s.id == it.id ? 'selected' : ''}
                      onClick={()=> { this.chooseOption(it) }}
                    >
                      { it.title }
                    </li>
                  ))}
                </ul>
              </Scrollbars>
            </div>

          </div>
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/javascript/website_default/js/react/shared/select/select.component.jsx